export default __webpack_public_path__ + "static/media/4.TRAZABILIDAD_WEB_SFS.1f6de567.mp4";